import AkeroCore from '@akerolabs/akero-vue/src/index'
import LoadingProgrammatic from '@akerolabs/akero-vue/src/components/loading/index.js'
import ModalProgrammatic from '@akerolabs/akero-vue/src/components/modal/index.js'
import DialogProgrammatic from '@akerolabs/akero-vue/src/components/dialog/index.js'
import ToastProgrammatic from '@akerolabs/akero-vue/src/components/toast/index.js'
import SnackbarProgrammatic from '@akerolabs/akero-vue/src/components/snackbar/index.js'
import NotificationProgrammatic from '@akerolabs/akero-vue/src/components/notification/index.js'
import MediaManagerProgrammatic from '@akerolabs/akero-vue/src/components/mediaManager/index.js'
import VariablesProgrammatic from '@akerolabs/akero-vue/src/components/variables/index.js'
import VariablesCKPlugin from '@akerolabs/akero-vue/src/components/textEditor/plugins/variables/index.js'
import { setBasePath } from '@akerolabs/akero-vue/src/utils/worker.js'
import i18n from '@akerolabs/akero-vue/src/utils/i18n.js'
import Router from './router'

/**
 * @param {Object} $locationProvider
 * @param {Object} $stateProvider
 * @param {Object} $urlRouterProvider
 * @param {Object} $ngVueProvider
 * @description
 */
function config(
  $locationProvider,
  $stateProvider,
  $urlRouterProvider,
  $ngVueProvider,
) {
  // here we set the base path to look for worker files
  setBasePath('/js/workers')

  i18n.global.locale = 'en'
  $ngVueProvider.use(i18n)
  $ngVueProvider.use(Router)
  $ngVueProvider.use(AkeroCore)
  $ngVueProvider.use(LoadingProgrammatic)
  $ngVueProvider.use(ModalProgrammatic)
  $ngVueProvider.use(DialogProgrammatic)
  $ngVueProvider.use(ToastProgrammatic)
  $ngVueProvider.use(SnackbarProgrammatic)
  $ngVueProvider.use(NotificationProgrammatic)
  $ngVueProvider.use(MediaManagerProgrammatic)
  $ngVueProvider.use(VariablesProgrammatic)
  $ngVueProvider.use(VariablesCKPlugin)

  $locationProvider.html5Mode(true)
  $urlRouterProvider.otherwise('/')

  // This is to allow us to be able to add resolves to route handlers on the
  // fly, an example of these would be in the app editors preventing you from
  // leaving the editor until you confirm you want to loose the changes.
  const $delegate = $stateProvider.state

  $stateProvider.state = function (name, definition) {
    if (!definition.resolve) {
      definition.resolve = {}
    }
    return $delegate.apply(this, arguments)
  }
}

config.$inject = [
  '$locationProvider',
  '$stateProvider',
  '$urlRouterProvider',
  '$ngVueProvider',
]

export default config
